// apps/merchant-v3/src/components/LoadingShell.tsx
//
// Phase 6 Wave 1 Task 02 — Suspense fallback used by lazy-loaded route
// modules in `router.tsx`. Renders a centered spinner inside the main
// content area so the shell (Sidebar + TopBar) stays visible while the
// page chunk loads.
//
// vg-binding: PLAN:task-02

import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function LoadingShell(): JSX.Element {
  const { t } = useTranslation('common');
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={t('a11y.loadingPage')}
      className="flex h-full min-h-[40vh] w-full items-center justify-center"
    >
      <Loader2 className="h-6 w-6 animate-spin text-brand-500" />
      <span className="sr-only">{t('actions.loading')}</span>
    </div>
  );
}

export default LoadingShell;
